{
  "nl": {
    "company": {
      "actions": {
        "changeCompany": "Verander bedrijf",
        "searchCompany": "Zoek bedrijf"
      },
      "attributes": {
        "address": "Adres",
        "email_address": "Email",
        "iban": "IBAN",
        "language": "Taal",
        "name": "Bedrijfsnaam",
        "phone": "Telefoon",
        "subdomain": "Subdomein",
        "vat": "BTW"
      },
      "labels": {
        "company": "Bedrijf",
        "contact": "Contactpersoon",
        "contacts": "Contactpersonen",
        "language": "Dit is de standaardtaal van het bedrijf voor jouw inlogpagina, klanten en teamleden.",
        "or": "OF"
      },
      "validation": {
        "contactAlreadyExist": "Contactpersoon bestaat al reeds",
        "mustBeEmailAddress": "Valide emailadres vereist",
        "needName": "Naam is vereist"
      }
    }
  }
}